import { Box, Button } from '@zillow/constellation-10';

import type { LateRentModel } from '@renter-hub/models/Types';
import DashboardSubheadingModel from '@renter-hub/models/DashboardSubheading';
import { DashboardSubheading } from '@common/components/DashboardSubheading/DashboardSubheading.component';

interface Props {
  transactions: Array<LateRentModel>;
  payLateRentPaymentOnClick: (scheduleMonth: string) => void;
}

export const OutstandingBalanceItems = ({ transactions, payLateRentPaymentOnClick }: Props) => {
  return (
    <>
      {transactions.map((transaction, i) => (
        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: { base: '6fr 6fr', md: '9fr 3fr' },
            margin: 'default',
          }}
          className="fs-exclude"
          key={`transactions${i}`}
        >
          <Box>
            <DashboardSubheading statement={DashboardSubheadingModel(transaction.rentPaymentSubheading).statement} />
          </Box>
          <Box
            css={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Button emphasis="filled" size="sm" onClick={() => payLateRentPaymentOnClick(transaction.scheduleMonth)}>
              Pay now
            </Button>
          </Box>
        </Box>
      ))}
    </>
  );
};
